module.exports = __webpack_public_path__ + "img/lottery.b272db06.jpg";